"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CustomProperty {
}
exports.default = CustomProperty;
//# sourceMappingURL=CustomProperty.js.map